/**
 * Macboot Variant Availability Fix
 * 
 * Problem: Theme JS removes [disabled] and .disabled classes from variant
 * options on page load when data-unavailable-variants="show". Combined with
 * data-variant-required (no pre-selected variant), users see all sizes as
 * available even when they're out of stock.
 *
 * Fix: Restore the visual disabled style based on data-available="false"
 * BEFORE any user interaction. Keep inputs clickable so customers can select
 * an out-of-stock size and trigger the back-in-stock form.
 */
(function() {
  'use strict';
  if (window.__macbootAvailabilityFixLoaded) return;
  window.__macbootAvailabilityFixLoaded = true;

  function applyDisabledFromAvailable(container) {
    // Find all elements with data-available="false"
    var unavailable = container.querySelectorAll('[data-available="false"]');
    unavailable.forEach(function(el) {
      // Skip if URL-redirect option (combined listing)
      if (el.hasAttribute('data-product-url')) return;
      
      // Keep the option visually unavailable, but selectable for back-in-stock.
      el.removeAttribute('disabled');
      el.removeAttribute('data-disabled');
      // Find parent label or wrapper and add .disabled class
      var wrapper = el.closest('.product-variant__item, .product-variant-value');
      if (wrapper && !wrapper.classList.contains('disabled')) {
        wrapper.classList.add('disabled');
      }
    });
  }

  function isNoVariantSelected(productVariants) {
    // Check if no variant selected yet (variantRequired mode)
    if (!productVariants.hasAttribute('data-variant-required')) return false;
    var checked = productVariants.querySelectorAll('input[type="radio"]:checked, option[selected]');
    return checked.length === 0;
  }

  function fixAllProductVariants() {
    var allPVs = document.querySelectorAll('product-variants');
    allPVs.forEach(function(pv) {
      if (isNoVariantSelected(pv)) {
        applyDisabledFromAvailable(pv);
      }
    });
  }

  function init() {
    // First pass — immediately
    fixAllProductVariants();

    // Second pass — after theme JS has initialized (theme uses connectedCallback)
    setTimeout(fixAllProductVariants, 100);
    setTimeout(fixAllProductVariants, 500);
    setTimeout(fixAllProductVariants, 1500);

    // Watch for dynamically-added product-variants (AJAX product loads)
    var observer = new MutationObserver(function(mutations) {
      mutations.forEach(function(m) {
        m.addedNodes.forEach(function(node) {
          if (node.nodeType !== 1) return;
          if (node.tagName === 'PRODUCT-VARIANTS') {
            setTimeout(function() {
              if (isNoVariantSelected(node)) {
                applyDisabledFromAvailable(node);
              }
            }, 100);
          } else if (node.querySelectorAll) {
            var pvs = node.querySelectorAll('product-variants');
            pvs.forEach(function(pv) {
              setTimeout(function() {
                if (isNoVariantSelected(pv)) {
                  applyDisabledFromAvailable(pv);
                }
              }, 100);
            });
          }
        });
      });
    });
    observer.observe(document.body, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
